import {render} from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {registerMicroApps, start} from 'qiankun';
import {unloadApplication} from 'single-spa';
import '@/styles';
import App from '@/components/App';
import {getUrlPurePathName} from '@/utils';
const managerRouter = [
    '/idaas/personal-center',
    '/idaas/other-login',
    '/idaas/more-provider',
    '/idaas/my-app',
    '/idaas/my-log',
    '/idaas/reset-pass',
    '/',
];
const platRouterArr = [
    '/idaas/project/detail',
    '/idaas/overView/user',
];
const isOnline = window.location.hostname === 'console.bce.baidu.com';
const puduClient = `https://bce.bdstatic.com/fe-static/baidu/bce-idaas/idaas-user-frontend/secret-cloud-pudu/${isOnline ? 'online.html' : 'sandbox.html'}`;
const publicClient = `https://bce.bdstatic.com/fe-static/baidu/bce-idaas/idaas-user-frontend/${isOnline ? 'online.html' : 'sandbox.html'}`;
const publicAdminClient = `https://bce.bdstatic.com/fe-static/baidu/bce-console/console-idaas/${isOnline ? 'online.html' : 'sandbox.html'}`;
const publicIdaasPlat = `https://bce.bdstatic.com/fe-static/baidu/eop-plat/idaas-plat-frontend/${isOnline ? 'online.html' : 'sandbox.html'}`;
const cdnDeploy = process.env.URL_PREFIX?.startsWith('http');
const registerMap = {
    'pudu': [
        {
            name: 'user-frontend',
            entry: cdnDeploy ? puduClient : '/idaas/pudu/index.html',
            container: '#idass-frontend-framework__main',
            activeRule: location => {
                return managerRouter.includes(getUrlPurePathName(location));
            },
        },
        {
            name: 'console-idaas-pudu',
            entry: '/idaas/admin/index.html',
            container: '#idass-frontend-framework__main',
            activeRule: location => {
                return location.href.replace(location.origin, '').startsWith('/idaas/#');
            },
        },
    ],
    'publicCloud': [
        {
            name: 'user-frontend',
            entry: cdnDeploy ? publicClient : '/idaas/user/index.html',
            container: '#idass-frontend-framework__main',
            activeRule: location => {
                return managerRouter.includes(getUrlPurePathName(location));
            },
        },
        {
            name: 'console-idaas-public',
            entry: cdnDeploy ? publicAdminClient : '/idaas/admin/index.html',
            container: '#idass-frontend-framework__main',
            activeRule: location => {
                const locationStr = location.href.replace(location.origin, '');
                return locationStr.startsWith('/idaas/#')
                || locationStr.startsWith('/idaas/?_');
            },
            props: {
                parentWindow: window,
            },
        },
        {
            name: 'idaas-plat-frontend',
            entry: publicIdaasPlat,
            container: '#idass-frontend-framework__main_new',
            activeRule: location => {
                const locationStr = location.href.replace(location.origin, '');
                return platRouterArr.filter(str => locationStr.indexOf(str) >= 0).length > 0;
            },
        },
    ],
    'guiyang': [
        {
            name: 'user-frontend',
            entry: cdnDeploy ? publicClient : '/static/user/index.html',
            container: '#idass-frontend-framework__main',
            activeRule: location => {
                return managerRouter.includes(getUrlPurePathName(location));
            },
        },
        {
            name: 'console-idaas-public',
            entry: cdnDeploy ? publicAdminClient : '/idaas/admin/index.html',
            container: '#idass-frontend-framework__main',
            activeRule: location => {
                const locationStr = location.href.replace(location.origin, '');
                return locationStr.startsWith('/idaas/#')
                || locationStr.startsWith('/idaas/?_');
            },
        },
    ],
};
const microArrs = registerMap[process.env.PROJECT];
registerMicroApps(microArrs, {
    afterUnmount: async app => {
        await unloadApplication(app.name);
        return Promise.resolve();
    },
});

start({
    sandbox: {
        experimentalStyleIsolation: true,
    },
    singular: false,
    excludeAssetFilter: (assetUrl: string) => assetUrl === 'https://code.bdstatic.com/npm/antd@4.16.13/dist/antd.min.css',
});

render(
    <Router>
        <App />
    </Router>,
    document.body.appendChild(document.createElement('div'))
);
